export const activePracticeQuesIndex = (index) => dispatch => {
    dispatch( {
        type: 'PRACTICE_QUESTION_INDEX',
        payload: index
    });
};